module.exports = "<md-content class=md-padding layout-xs=column layout=row> <div flex-xs flex-gt-xs=30 layout=column> <level-teaser title=\"Prologue - Okinawan Onigiri!\" description=\"A weird dream is haunting you during your sleep...\" image-url={{lpc.prologueTeaserUrl}} share=\"prologue level: Okinawan Onigiri!\" state=\"level-page({level: 'prologue'})\"></level-teaser> </div> </md-content> ";


//////////////////
// WEBPACK FOOTER
// ./components/pages/levelsPage/levelsPage.html
// module id = 49
// module chunks = 0